import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DIMENSIONS } from 'services/layoutManager';
//import { FilterProvider } from 'context/FilterContext';
import { AvatarApi } from 'services/avatar';
import BloxPage from 'sub_components/Layout/BloxPage';
import ComponentWrapper from 'sub_components/Layout/ComponentWrapper';
import { RESOLUTIONS } from 'services/config';
import { ColoGraph } from 'styled_components/Colo/ColoGraph';
//import { Filter } from 'styled_components/Common/Filter';
import { updateModule, updatePage, addPageToBreadCrumbs } from 'actions/siteTracking';
import { updatePermissions } from 'actions/permissions';
import { setHomeTour } from 'actions/tour';
import { updateUsers } from 'actions/company';
import { MENU as COLO_MENU } from 'utils/ColoConstants';
import { SITE_PAGES, SITE_MODULES } from 'utils/CommonConstants';
import { Permissions } from 'services/permissions';
import { CompanyProfileApi } from 'services/companyProfile';

//const Filtering = ['All', 'Atlanta', 'Birmingham'];

const LAYOUT_CONFIG = {
	[RESOLUTIONS.LOW]: {
		component1: { x: 1, y: 4, dim: DIMENSIONS.FOUR_BY_EIGHT },
		component2: { x: 9, y: 4, dim: DIMENSIONS.FOUR_BY_FOUR },
	},
	[RESOLUTIONS.MED]: {
		component1: { x: 1, y: 42, dim: DIMENSIONS.FOUR_BY_EIGHT },
		component2: { x: 9, y: 42, dim: DIMENSIONS.SIX_BY_FOUR },
	},
	[RESOLUTIONS.HIGH]: {
		component1: { x: 1, y: 60, dim: DIMENSIONS.FOUR_BY_EIGHT },
		component2: { x: 9, y: 60, dim: DIMENSIONS.SIX_BY_FOUR },
	},
};

class RackOverview extends Component {
	constructor(props) {
		super(props);
		this.avatarApi = new AvatarApi();
		this.companyApi = new CompanyProfileApi();
		this.state = {
			role: null,
			selected: 'All',
			view: 'power',
		};
	}

	setView = view => {
		this.setState({ view });
	};

	componentDidMount() {
		const { updateModule, updatePage, addPageToBreadCrumbs, site, permissions } = this.props;
		updatePage(SITE_PAGES.COLO[COLO_MENU.RACK]);
		addPageToBreadCrumbs(SITE_PAGES.COLO[COLO_MENU.RACK], SITE_MODULES.COLO);

		if (site?.module !== SITE_MODULES.COLO || !permissions?.permissions) {
			this.getModulePages();
		}
		updateModule(SITE_MODULES.COLO);
	}

	getUsersRole = id => {
		const { auth_status } = this.props;
		const { role } = this.state;
		const { memberships = {} } = auth_status;
		const currentMembershipSelected = memberships.filter(
			membership => Number(membership.organizationId) === Number(id),
		);
		if (currentMembershipSelected[0].role !== role) {
			this.setState({ role: currentMembershipSelected[0].role });
		}
		return currentMembershipSelected[0].role;
	};

	goToPortalManagement = active => {
		const { navigate } = this.props;
		navigate('/portal/account/user_management', { active });
	};
	getModulePages = async () => {
		const {
			updatePermissions,
			auth_status: {
				user: { id: userId },
			},
			company_info: {
				customer: { id: orgId },
			},
		} = this.props;
		const response = await Permissions.getModulePermissions(5, userId, orgId);

		if (response && !response.data.error) {
			updatePermissions(response.data.pages);
		}
	};
	goToTicketHistory = (status, type) => {
		const { navigate } = this.props;
		navigate('/portal/support/ticket_history', { state: { status, type } });
	};

	setSelectedInformation = selectedInformation => {
		this.setState({ selectedInformation });
	};

	goToPage = page => {
		const { navigate } = this.props;
		navigate(`/portal/colocation/${page}`);
	};

	goToTicketHistory = (status, type) => {
		const { navigate } = this.props;
		navigate('/portal/support/ticket_history', { state: { status, type } });
	};
	setSelected = selected => {
		this.setState({ selected: option.toLowerCase() });
		console.log('hello', selected);
	};

	render() {
		const {
			breakpoint,
			location,
			////permissions: pages,
			//navigate,
			company_info: {
				customer: { id },
			},
		} = this.props || {};
		//const { selected } = this.state;

		return (
			<BloxPage
				name='page colocation'
				layout={LAYOUT_CONFIG[breakpoint]}
				breakpoint={breakpoint}
				location={location}
			>
				<div key={`component1`} className='component1'>
					<ComponentWrapper title='' hideBorder>
						{/* <FilterProvider>
							<Filter
								module='colo'
								selected={selected}
								options={Filtering}
								callback={this.setSelected}
								filterHeading='Data Center'
							/>
						</FilterProvider> */}
						<ColoGraph breakpoint={breakpoint} module={module} orgId={id} />
					</ComponentWrapper>
				</div>
				<div key={`component2`} className='component2'>
					<ComponentWrapper hideBorder title=''></ComponentWrapper>
				</div>
			</BloxPage>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
		company_info: state.company_info,
		site: state.site_tracking,
		permissions: state.permissions,
	};
}

export default connect(mapStateToProps, {
	updateModule,
	updatePage,
	addPageToBreadCrumbs,
	updateUsers,
	updatePermissions,
	setHomeTour,
})(RackOverview);
